/*
 * DefaultEditor.jsx
 *
 * Speakers
 * Created by Mahdi Yousefpour on Sat Feb 04 2023 mys Company
 */

import { useEffect, useState } from 'react'
import uuid from 'react-uuid'
import { CKEditor } from '@ckeditor/ckeditor5-react'
import ClassicEditor from '@ckeditor/ckeditor5-build-classic'

const DefaultEditor = ({ label, id, name, hint, value, inputClassName, className, onBlur, onChange, formik }) => {
    // MARK: VARIABLE
    const [uuId, setUuId] = useState()

    // MARK: METHOD
    useEffect(() => {
        setUuId(uuid())
    }, [])

    return (
        <>
            <div className={` ${className ?? ''}`}>
                <label className={`w-100 block  text-sm `}>
                    {label} <span className={`text-xs text-gray-400 inline ${hint ? '' : 'hidden'}`}> - {hint}</span>
                </label>

                <CKEditor
                    name={name}
                    id={id ?? name + '_' + uuId}
                    editor={ClassicEditor}
                    data={value ?? ''}
                    config={{
                        toolbar: [
                            'heading',
                            '|',
                            'bold',
                            'italic',
                            'blockQuote',
                            'link',
                            'numberedList',
                            'bulletedList',
                            '|',
                            'imageUpload',
                            'insertTable',
                            'tableColumn',
                            'tableRow',
                            'mergeTableCells',
                            'mediaEmbed',
                            '|',
                            'undo',
                            'redo',
                        ],
                    }}
                    className={`w-full border border-gray-100 rounded shadow-sm p-2 outline-none ${inputClassName ?? ''}`}
                    onReady={(editor) => {
                        // You can store the "editor" and use when it is needed.
                        //console.log('Editor is ready to use!', editor)
                    }}
                    onChange={(event, editor) => {
                        const data = editor.getData()
                        if (onChange) onChange(data)
                        formik.setFieldValue(name, data)
                        //console.log({ event, editor, data })
                    }}
                    onBlur={(event, editor) => {
                        //console.log('Blur.', editor)
                        if (onBlur) onBlur(editor.getData())
                    }}
                    onFocus={(event, editor) => {
                        //console.log('Focus.', editor)
                    }}
                />
            </div>
            {/* <div className={`text-red-500 text-xs `}>{formik.errors[name] && formik.touched[name] ? formik.errors[name] : null}</div> */}
        </>
    )
}

export default DefaultEditor

// 'heading',
// '|',
// 'fontfamily',
// 'fontsize',
// '|',
// 'alignment',
// 'autoformat',
// '|',
// 'fontColor',
// 'fontBackgroundColor',
// '|',
// 'bold',
// 'italic',
// 'blockQuote',
// 'underline',
// 'subscript',
// 'superscript',
// 'link',
// 'numberedList',
// 'bulletedList',
// 'todoList',
// '|',
// 'imageUpload',

// 'insertTable',
// 'tableColumn',
// 'tableRow',
// 'mergeTableCells',
// 'mediaEmbed',
// 'code',
// 'codeBlock',

// '|',
// 'undo',
// 'redo',
